module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_shape_top-cc0c961804e68833882873d9b826f81d.png";